import {
  Component, ChangeDetectionStrategy, Input,
} from '@angular/core'
import { ColumnWidth } from '@knorr-bremse-portals/ngx-components'
import { HeadingLevel } from '@knorr-bremse-portals/ngx-components/components/variable-heading'
import {
  CropType, VideoComponent,
} from '@knorr-bremse-portals/ngx-components/components/video'
import {
  AbstractMode, OverlayFigureComponent,
} from '@knorr-bremse-portals/ngx-components/components/overlay-figure'

@Component({
  selector: 'kb-hero-video',
  templateUrl: './hero-video.component.html',
  styleUrls: ['./hero-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OverlayFigureComponent, VideoComponent],
})
export class HeroVideoComponent {
  @Input({ required: true }) public src!: string
  @Input({ required: true }) public poster!: string
  @Input({ required: true }) public rootColumns!: ColumnWidth
  @Input() public crop: CropType = 'fit'
  @Input() public autoplay?: boolean
  @Input() public loop?: boolean
  @Input() public heading?: string
  @Input() public headingLevel: HeadingLevel = 2
  @Input() public abstract?: string
  @Input() public indented = true
  @Input() public largeHeading = true
  @Input() public abstractMode: AbstractMode = 'visible'
}
